import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Typography,
  IconButton,
  SvgIcon,
} from '@material-ui/core'
import { mdiPencil } from '@mdi/js'

import UnitFormDialog from './UnitFormDialog'

class UnitDetailsView extends React.Component {
  static propTypes = {
    unit: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
  }

  static styles = {}

  state = {
    isEditing: false,
  }

  handleEditClick = () => {
    this.setState({ isEditing: true })
  }

  handleClose = () => {
    this.setState({ isEditing: false })
  }

  render() {
    const { unit } = this.props
    const { isEditing } = this.state

    return (
      <>
        { unit.name
          && (
            <Typography variant="h6">
              {unit.name || unit.id}
              <IconButton aria-label="Edit" onClick={this.handleEditClick}>
                <SvgIcon>
                  <path d={mdiPencil} />
                </SvgIcon>
              </IconButton>
            </Typography>
          )}
        { (unit.location && unit.location.address)
          && <Typography variant="subtitle1">{unit.location.address}</Typography>}
        { isEditing && (
          <UnitFormDialog
            title={`Edit Unit ${(unit && unit.id) || ''}`}
            onSubmit={this.props.onSave}
            onClose={this.handleClose}
            unit={unit}
          />
        )}
      </>
    )
  }
}

export default withStyles(UnitDetailsView.styles)(UnitDetailsView)
